import { render, staticRenderFns } from "./touchHelpList.vue?vue&type=template&id=7faab70f&scoped=true&"
import script from "./touchHelpList.vue?vue&type=script&lang=js&"
export * from "./touchHelpList.vue?vue&type=script&lang=js&"
import style0 from "./touchHelpList.vue?vue&type=style&index=0&id=7faab70f&prod&lang=scss&scoped=true&"
import style1 from "./touchHelpList.vue?vue&type=style&index=1&id=7faab70f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faab70f",
  null
  
)

export default component.exports